//@ts-nocheck

import styled, { css } from 'styled-components'

interface BentoBoxWrapperProps {
  $bentosCardAlignment?: 'double-equal' | 'triple-equal' | 'triple-biggerLeft' | 'triple-biggerRight' | 'double-biggerRight' | 'double-biggerLeft' | 'full-centered' | 'full-horizontal'
  theme?: any
}

export const BentoBoxWrapper = styled.div<BentoBoxWrapperProps>`
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.rem(24)};
  
  ${({ theme }) => theme.mediaQuery.lg(`
    display: grid;
    justify-content: space-between;
  `)}

  ${({ theme, $bentosCardAlignment }) => {
    const padding = theme.rem(0)
    const unset = 'unset'

    switch ($bentosCardAlignment) {
      case 'double-equal':
        return css`
          ${theme.mediaQuery.lg(`
            padding: ${padding};
            grid-template-rows: ${unset};
            grid-template-columns: 49% 49%;
          `)}
        `
      case 'triple-equal':
      case 'triple-biggerLeft':
      case 'triple-biggerRight':
        return css`
          ${theme.mediaQuery.lg(`
            padding: ${padding};
            grid-template-rows: ${unset};
            grid-template-columns: 32% 32% 32%;
          `)}
        `
      case 'double-biggerRight':
        return css`
          grid-template-rows: minmax(min-content, 32%) minmax(min-content, 66%);

          ${theme.mediaQuery.lg(`
            padding: ${padding};
            grid-template-rows: ${unset};
            grid-template-columns: 42% 54%;
          `)}

          ${theme.mediaQuery.lg(`
            .box-wrapper {
              &:last-child {
                .bento-box-shape {
                  > svg {
                    position: absolute;
                    right: -10%;
                  }
                }
              }
            }
          `)}
        `
      case 'double-biggerLeft':
        return css`
          grid-template-rows: minmax(min-content, 66%) minmax(min-content, 32%);

          ${theme.mediaQuery.lg(`
            padding: ${padding};
            grid-template-rows: ${unset};
            grid-template-columns: 54% 42%;
          `)}

          ${theme.mediaQuery.lg(`
            .box-wrapper {
              &:first-child {
                .bento-box-shape {
                  > svg {
                    position: absolute;
                    right: -10%;
                  }
                }
              }
            }
          `)}
        `
      case 'full-centered':
      case 'full-horizontal':
        return css`
          ${theme.mediaQuery.lg(`
            display: flex;
          `)}
        `
      default:
        return ''
    }
  }}
`

interface StyledProps {
  theme: any
}

export const SwiperWrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: column;
  
  .swiper {
    width: 100%;
  }

  .swiper-wrapper {
    max-width: 90dvw;

    ${({ theme }) =>
      theme.mediaQuery.lg(`
      padding: ${theme.rem(40, 0)};
    `)}

    .swiper-slide {
      height: auto !important;
    }
  }
`
export const Navigation = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.rem(24)};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NavigationButton = styled.div<StyledProps>`
  position: relative;
  padding: ${({ theme }) => theme.rem(0, 10)};
  top: auto;
  left: auto;
  transform: translateY(0);
  z-index: 1;

  ${({ theme }) =>
    theme.mediaQuery.sm(`
    position: absolute;
    padding: 0;
    top: 50%;
    transform: translateY(-50%);
  `)}

  button {
    &:first-of-type {
      margin-left: 0;
    }

    &.swiper-button-lock {
      display: none;
    }
  }
`

export const ButtonPrev = styled(NavigationButton)`
  left: 0;

  ${({ theme }) =>
    theme.mediaQuery.sm(`
    left: -52px;
  `)}
`

export const ButtonNext = styled(NavigationButton)`
  right: 0;

  ${({ theme }) =>
    theme.mediaQuery.sm(`
    right: -52px;
  `)}
`

export const NavScrollbar = styled.div<StyledProps>`
  width: 100%;
  height: 3px;
  background: var(--buttons-icon-only-icon-background, #cfc6be);
  background-size: 3px;

  &:has(.swiper-scrollbar-drag) {
    height: 3px;
  }
  .swiper-scrollbar-drag {
    margin-top: 1px;
    height: 1.5px;
  }

  ${({ theme }) =>
    theme.mediaQuery.lg(
      `
    margin-top: ${theme.rem(24)};
  `,
      true
    )}
`
